import React, { Component } from "react";
import India from "../images/HeroBanner/IndiaImg.svg";
import whatsappIcon from "../images/HeroBanner/whatsappIcon.svg";
import msgIcon from "../images/HeroBanner/msgIcon.svg";
import "../css/SgCampaign.css";
import ImageDesktop from "../images/HeroBanner/ImageDesktop.svg";
import Imagemobile from "../images/HeroBanner/Imagemobile.svg";
// import NavBar from "./NavBar"
import tick from "../images/HeroBanner/tick.svg";
import Section1Img from "../images/HeroBanner/Section1Img.png";
import Ellipse from "../images/HeroBanner/Ellipse.png";
import SGDektopImg from "../images/HeroBanner/SG-DektopImg.png";
import SGMobileImg from "../images/HeroBanner/SG-MobileImg.png";

import Form from "./Form";
class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="Section1">
        <div className="Section1-body">
          <div className="Section1-col1">
            {window.screen.width > 700 ? (
              " "
            ) : (
              <img
                src={Ellipse}
                alt="background"
                style={{ position: "absolute", zIndex: "-1", bottom: "30px", }}
              />
            )}
            <img
              src={window.screen.width > 700 ? SGDektopImg : SGMobileImg}
              alt=""
              style={{ zIndex: "-1", width: "150%" }}
            />
          </div>
          <div className="Section1-col2">
            <div className="landing__form">
              <div className="landing__form--header">
                <div className="landing__form--header--heading">
                  Aapki Coaching, Aapki App
                </div>
                <div className="landing__form--header--subheading">
                  Fuel your teaching with the power of technology and teach
                  millions of students
                </div>
              </div>
              <div>
                <Form source="landing" />
              </div>
            </div>
            {/*<img
							src={window.screen.width > 700 ? Section1Img : Section1ImgMobile}
							alt=""
							style={window.screen.width > 700 ? { width: '507px', height: '448px' } : {}}
						/>*/}
          </div>
        </div>
      </div>
    );
  }
}

export default Banner;
